/* TWRD quick add modal — Black & White only.
   The bag button on a card opens one shared dialog. Product data comes from
   /products/<handle>.js. The add reuses the theme product-form, so the theme
   cart store updates and the theme cart drawer opens as usual. */
(function () {
  'use strict';

  /* The dialog snippet and this file are now included by every section that
     renders product cards (grid, featured collections, recommendation rails).
     Two sections on one page must still give one dialog and one set of
     listeners, so both are guarded here rather than in each section. */
  if (window.__twrdQuickAddInit) return;
  window.__twrdQuickAddInit = true;

  var CACHE = {};
  /* In-flight fetches, so a warm-up and a click share one request. */
  var PENDING = {};
  /* Handles already warmed on intent. One warm-up per product. */
  var WARMED = {};
  /* The main image and its warm-up copy use the same srcset and sizes, so
     the browser picks the same file for both. Desktop: the media column is
     about 355 to 490 CSS px wide. Mobile: the main image is hidden and
     46vw matches thumb 1, so both share one file. */
  var MAIN_SIZES = '(max-width: 749.98px) 46vw, 490px';
  var THUMB_SIZES = '(max-width: 749px) 46vw, 140px';
  /* Most images one open may preload in the background. */
  var QUEUE_MAX = 12;
  var COLOUR_NAMES = ['color', 'colour', 'farve'];
  var SIZE_NAMES = ['size', 'størrelse', 'storrelse'];
  /* The print option is named "Style" on some products and "Print Position"
     on others. Both drive the same front/back choice. */
  var STYLE_NAMES = ['style', 'print'];
  var DRAG_THRESHOLD = 6;
  var VERSE_MAX_REF_LEN = 40;
  /* Thumbs synlige paa een raekke paa desktop. Flere scroller. */
  var THUMBS_VISIBLE = 4;
  /* Arket lukker hurtigt, naar varen er lagt i: kurv-skuffen glider ind
     samtidig og er selve kvitteringen. De to maa ikke ligge oven i hinanden. */
  var FAST_CLOSE_MS = 130;
  var NUDGE_MS = 1400;
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  /* Smaa ord taeller ikke, naar en alt-tekst sammenlignes med produktnavnet. */
  var SMALL_WORDS = ['the', 'and', 'of', 'a', 'an', 'in', 'on', 'by', 'is', 'it'];
  var CLOSE_UP = /\b(close[\s-]?up|closeup|detail|fabric)\b/;
  var PERSON = /\b(wearing|worn|woman|women|man|men|model|girl|guy|person)\b/;

  var CHECK_SVG =
    '<svg class="twrd-qa__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" aria-hidden="true">' +
    '<path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  var SWATCH_COLOURS = {
    black: '#111111',
    white: '#f2f2f2',
    sand: '#b8a898',
    beige: '#b8a898',
    navy: '#414a5e',
    plum: '#5a3a5a',
    grey: '#8a8a8a',
    gray: '#8a8a8a',
    rose: '#f4a7c8'
  };

  var MAIL_SVG =
    '<svg class="twrd-qa__mail" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">' +
    '<rect x="2.5" y="5" width="19" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>';

  var STRIKE_SVG =
    '<svg class="twrd-qa__strike" viewBox="0 0 100 48" preserveAspectRatio="none" aria-hidden="true">' +
    '<line x1="100" y1="0" x2="0" y2="48"/></svg>';

  var state = {
    product: null,
    colorIndex: -1,
    sizeIndex: -1,
    styleIndex: -1,
    otherIndexes: [],
    preferred: null,
    selectedColor: null,
    selectedSize: null,
    selectedStyle: null,
    trigger: null,
    busy: false,
    /* 'idle' | 'adding' | 'added' */
    phase: 'idle',
    /* UPCOMING product (tag twrd-upcoming): sign-up instead of add. */
    upcoming: false,
    /* Sibling products (twrd.sibling_products / twrd.edition_siblings), from
       data attributes on the card button. [{ handle, label, swatch }]. */
    colourGroup: [],
    editionGroup: [],
    swapToken: 0,
    images: [],
    imageIndex: 0
  };

  var el = {};

  function q(name) {
    return document.querySelector('[data-twrd-qa-' + name + ']');
  }

  function collect() {
    var roots = document.querySelectorAll('[data-twrd-qa]');
    if (!roots.length) return false;
    /* Keep the first dialog only, so ids inside it stay unique on the page. */
    for (var i = 1; i < roots.length; i += 1) {
      if (roots[i].parentNode) roots[i].parentNode.removeChild(roots[i]);
    }
    el.root = roots[0];
    /* Dialogen flyttes til <body>. Den foerste kopi ligger ofte inde i en
       sektion (PDP-rail, grid) med transform, og saa er position: fixed
       bundet til sektionen, ikke til skaermen. Fra kurv-skuffen (z 999)
       havnede dialogen derfor bag skuffens overlay: klikket ramte overlayet,
       skuffen lukkede og fokus hoppede til posen i headeren. Paa <body> er
       z-index 1000 over skuffen. product-form binder sig igen ved flytning. */
    if (el.root.parentNode !== document.body) document.body.appendChild(el.root);
    el.sheet = q('sheet');
    el.body = q('body');
    el.loading = q('loading');
    el.failed = q('failed');
    el.failedLink = q('failedlink');
    el.content = q('content');
    el.media = q('media');
    el.mainImg = q('mainimg');
    el.images = q('images');
    el.link = q('link');
    el.eyebrow = q('eyebrow');
    el.title = q('title');
    el.colors = q('colors');
    el.colorName = q('colorname');
    el.colorLabel = q('colorlabel');
    el.swatches = q('swatches');
    el.editions = q('editions');
    el.editionLabel = q('editionlabel');
    el.editionTiles = q('editiontiles');
    el.sizeWrap = q('sizewrap');
    el.sizes = q('sizes');
    el.sizeLabel = q('sizelabel');
    el.sizeSep = q('sizesep');
    el.styles = q('styles');
    el.styleLabel = q('stylelabel');
    el.styleTiles = q('styletiles');
    el.verse = q('verse');
    el.verseText = q('versetext');
    el.verseRef = q('verseref');
    el.story = q('story');
    el.facts = q('facts');
    el.factList = q('factlist');
    el.grid = q('specs');
    el.sizeLink = q('sizelink');
    el.ship = q('ship');
    el.shipDate = q('shipdate');
    el.shipDot = q('shipdot');
    el.price = q('price');
    el.error = q('error');
    el.add = q('add');
    el.form = q('cartform');
    el.micro = q('micro');
    el.up = q('up');
    el.upForm = el.up ? el.up.querySelector('form') : null;
    el.upTags = q('uptags');
    el.upEmail = q('upemail');
    el.upSubmit = q('upsubmit');
    el.upError = q('uperror');
    el.upDone = q('updone');
    return true;
  }

  /* ---------- money ---------- */

  function money(cents) {
    return window.twrdFormatMoney(cents);
  }

  /* ---------- product helpers ---------- */

  function matchName(name, list) {
    var lower = String(name || '').toLowerCase();
    for (var i = 0; i < list.length; i += 1) {
      if (lower.indexOf(list[i]) !== -1) return true;
    }
    return false;
  }

  function optionValue(variant, index) {
    if (index < 0) return null;
    return variant.options[index] != null ? variant.options[index] : null;
  }

  function variantById(product, id) {
    if (!id) return null;
    var wanted = String(id);
    for (var i = 0; i < product.variants.length; i += 1) {
      if (String(product.variants[i].id) === wanted) return product.variants[i];
    }
    return null;
  }

  /* Variants that match the picked colour, size and style, best match first. */
  function candidates(color, size) {
    var style = state.selectedStyle;
    var pool = state.product.variants.filter(function (variant) {
      if (state.colorIndex >= 0 && color && optionValue(variant, state.colorIndex) !== color) return false;
      if (state.sizeIndex >= 0 && size && optionValue(variant, state.sizeIndex) !== size) return false;
      if (state.styleIndex >= 0 && style && optionValue(variant, state.styleIndex) !== style) return false;
      return true;
    });
    if (!state.preferred || !state.otherIndexes.length) return pool;
    var same = pool.filter(function (variant) {
      return state.otherIndexes.every(function (index) {
        return optionValue(variant, index) === optionValue(state.preferred, index);
      });
    });
    return same.length ? same : pool;
  }

  function resolve(color, size) {
    var pool = candidates(color, size);
    /* TWRD 2026-10-29: UPCOMING stock is 0. Every size stays open for the
       sign-up; the CTA is "Notify me" (addMode), so nothing can be added. */
    var available = state.upcoming ? pool : pool.filter(function (variant) {
      return variant.available;
    });
    return { variant: available[0] || pool[0] || null, available: available.length > 0 };
  }

  function colourFor(value) {
    var key = String(value || '').toLowerCase().trim();
    if (SWATCH_COLOURS[key]) return SWATCH_COLOURS[key];
    var words = key.split(/[\s/_-]+/);
    for (var i = 0; i < words.length; i += 1) {
      if (SWATCH_COLOURS[words[i]]) return SWATCH_COLOURS[words[i]];
    }
    return null;
  }

  /* ---------- render ---------- */

  /* Same file, different host or query, counts as one image. */
  function imageKey(src) {
    return String(src || '').split('?')[0].replace(/^https?:/, '').split('/').pop().toLowerCase();
  }

  function sized(src, width) {
    return String(src).replace(/(\.[a-z]+)(\?|$)/i, '_' + width + 'x$1$2');
  }

  function mainSrcset(src) {
    return sized(src, 700) + ' 700w, ' + sized(src, 1100) + ' 1100w';
  }

  function thumbSrcset(src) {
    return sized(src, 300) + ' 300w, ' + sized(src, 700) + ' 700w';
  }

  /* Billeder kun. En videos preview er ikke et ekstra billede (dublet). */
  function usable(item) {
    if (!item || isVideo(item)) return false;
    return !!(item.preview_image && item.preview_image.src);
  }

  function isVideo(item) {
    return item.media_type === 'video' || item.media_type === 'external_video';
  }

  /* Mp4 near 720p. Shopify-hostede videoer har sources, eksterne har ikke. */
  function videoSource(item) {
    var mp4 = (item.sources || []).filter(function (source) {
      return source.format === 'mp4' && source.url;
    });
    if (!mp4.length) return '';
    /* The big video is about 900px wide on desktop and full width on a phone.
       Pick the smallest file that is sharp at that size on this screen
       (720p looked soft on retina), else the largest there is. */
    var need = Math.min(window.innerWidth || 900, 920) * (window.devicePixelRatio || 1);
    var bySize = mp4.slice().sort(function (a, b) { return (a.width || 0) - (b.width || 0); });
    var best = bySize.filter(function (source) { return (source.width || 0) >= need; })[0] || bySize[bySize.length - 1];
    return best.url;
  }

  /* Videoen til farven som { src: poster, alt, video }. Kun een farve: enhver
     video. Flere farver: alt skal naevne farven. Hoejst een video. */
  function videoForColor(color) {
    var product = state.product;
    var single = state.colorIndex < 0 || !color || product.options[state.colorIndex].values.length < 2;
    var needle = String(color || '').toLowerCase();
    var match = (product.media || []).filter(function (item) {
      if (item.media_type !== 'video' || !item.preview_image || !videoSource(item)) return false;
      if (isForeign(item.alt)) return false;
      return single || String(item.alt || '').toLowerCase().indexOf(needle) !== -1;
    })[0];
    if (!match) return null;
    return { src: match.preview_image.src, alt: match.alt || '', video: videoSource(match) };
  }

  /* Media items to a new list of { src, alt }, duplicates dropped. */
  function toImages(items) {
    var seen = {};
    return items.reduce(function (list, item) {
      var key = imageKey(item.preview_image.src);
      if (!key || seen[key]) return list;
      seen[key] = true;
      return list.concat([{ src: item.preview_image.src, alt: item.alt || '' }]);
    }, []);
  }

  /* Lifestyle shots live elsewhere in the sheet, not in the image row. */
  function isLifestyle(alt) {
    return String(alt || '').toLowerCase().indexOf('lifestyle') !== -1;
  }

  /* ---------- hvilket produkt viser billedet ---------- */

  function flat(text) {
    return String(text || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function squash(text) {
    return flat(text).replace(/[^a-z0-9]/g, '');
  }

  function wordsOf(text) {
    return flat(text).split(/[^a-z0-9]+/).filter(function (word) {
      return word && SMALL_WORDS.indexOf(word) === -1;
    });
  }

  /* Navnet en alt-tekst giver billedet: teksten foer sidste " – " / " - ",
     uden " in Black". "Daughter Of The King in Black – Christian T-Shirt"
     giver "Daughter Of The King". Ingen bindestreg: intet navn. */
  function altName(alt) {
    var parts = String(alt || '').split(/\s[–—-]\s/);
    if (parts.length < 2) return '';
    return parts.slice(0, -1).join(' - ').replace(/\s+in\s+[a-z &\/-]+$/i, '').trim();
  }

  /* Alt-teksten navngiver et ANDET produkt. Delte stof-close-ups paa shoppen
     baerer navnet paa produktet de blev lavet til. Navnet taeller som vores,
     naar det staar i titel eller handle, eller alle dets ord goer. */
  function isForeign(alt) {
    var name = altName(alt);
    var short = squash(name);
    if (!short) return false;
    var product = state.product;
    var title = squash(product.title);
    var handle = squash(product.handle);
    if (title.indexOf(short) !== -1 || handle.indexOf(short) !== -1 || short.indexOf(title) !== -1) return false;
    var own = wordsOf(product.title).concat(wordsOf(product.handle));
    var words = wordsOf(name);
    return !(words.length && words.every(function (word) {
      return own.indexOf(word) !== -1;
    }));
  }

  /* Titel- og handle-ord uden farvenavne, til alt-tekster uden bindestreg. */
  function productWords() {
    var product = state.product;
    var colours = state.colorIndex >= 0
      ? wordsOf(product.options[state.colorIndex].values.join(' '))
      : [];
    return wordsOf(product.title + ' ' + product.handle).filter(function (word, index, list) {
      return colours.indexOf(word) === -1 && list.indexOf(word) === index;
    });
  }

  /* Alt-teksten peger paa dette produkt: navnet er vores, eller mindst
     halvdelen af produktets ord staar i den. */
  function referencesProduct(alt) {
    if (altName(alt)) return !isForeign(alt);
    var own = productWords();
    if (!own.length) return true;
    var words = wordsOf(alt);
    var hits = own.filter(function (word) {
      return words.indexOf(word) !== -1;
    }).length;
    return hits * 2 >= own.length;
  }

  /* Produktbilledet foerst, saa baaret, close-ups sidst. Raekkefoelgen
     inden for hver gruppe er media-raekkefoelgen. Ny liste, input roeres ikke. */
  function shotRank(alt) {
    var lower = String(alt || '').toLowerCase();
    if (CLOSE_UP.test(lower)) return 2;
    if (PERSON.test(lower)) return 1;
    return 0;
  }

  function leadWithProduct(items) {
    return items
      .map(function (item, index) {
        return { item: item, index: index, rank: shotRank(item.alt) };
      })
      .sort(function (a, b) {
        return a.rank - b.rank || a.index - b.index;
      })
      .map(function (entry) {
        return entry.item;
      });
  }

  /* Produktets egne billeder: ikke lifestyle, ikke et andet produkts.
     Er der ingen, lifestyle hellere end et tomt ark. */
  function allImages() {
    var media = (state.product.media || []).filter(usable);
    var own = media.filter(function (item) {
      return !isLifestyle(item.alt) && !isForeign(item.alt);
    });
    if (!own.length) {
      own = media.filter(function (item) {
        return !isForeign(item.alt);
      });
    }
    if (!own.length) own = media;
    var list = toImages(leadWithProduct(own));
    if (list.length) return list;
    return (state.product.images || []).map(function (src) {
      return { src: src, alt: '' };
    });
  }

  /* Alt "back print edition" marks the Back print edition. "front print" or
     "back print" without "edition" belongs to the Front print edition. */
  function isBackEdition(alt) {
    return String(alt || '').toLowerCase().indexOf('back print edition') !== -1;
  }

  function styleIsBack(value) {
    return String(value || '').toLowerCase().indexOf('back') === 0;
  }

  /* View ('front' / 'back' / '') from the alt text. Same rule as
     snippets/twrd-alt-view.liquid: split on ", ", walk backwards, the last
     segment that starts with "front print" / "back print" wins. The segment
     "back print edition" is edition, not view, and is skipped. No match:
     fall back to a plain "back" / "front" substring with the edition phrase
     removed, so "back print edition" alone never means view back. */
  function viewFromAlt(altText) {
    var lower = String(altText || '').toLowerCase();
    var segments = lower.split(', ');
    for (var i = segments.length - 1; i >= 0; i--) {
      var seg = segments[i].trim();
      if (seg.indexOf('print edition') !== -1) continue;
      var match = /^(front|back) print/.exec(seg);
      if (match) return match[1];
    }
    var rest = lower.replace(/(front|back) print edition/g, '');
    if (rest.indexOf('back') !== -1) return 'back';
    if (rest.indexOf('front') !== -1) return 'front';
    return '';
  }

  /* Non lifestyle media whose alt names the colour, in media order.
     Media whose alt names another product is never ours. */
  function mediaForColor(color) {
    var needle = String(color).toLowerCase();
    return (state.product.media || []).filter(function (item) {
      if (!usable(item)) return false;
      if (isLifestyle(item.alt) || isForeign(item.alt)) return false;
      return String(item.alt || '').toLowerCase().indexOf(needle) !== -1;
    });
  }

  /* Media for the colour, narrowed to the picked Style edition. Back print
     shows only edition media when any exist; otherwise the front set. */
  function mediaForColorAndStyle(color) {
    var all = mediaForColor(color);
    var edition = all.filter(function (item) {
      return isBackEdition(item.alt);
    });
    var front = all.filter(function (item) {
      return !isBackEdition(item.alt);
    });
    if (styleIsBack(state.selectedStyle) && edition.length) return edition;
    return front.length ? front : all;
  }

  /* Images for the picked colour, as { src, alt }. The alt text is the
     reliable signal on this shop: several variants point at the featured
     image of the other colour, so alt and file name come first and the
     variant image is the fallback.
     Regel: kun een farve giver produktets egne billeder. Ellers skal
     farve-saettet have mindst eet billede hvis alt peger paa dette produkt;
     fil-navn og variant-billede er reserven, egne billeder den sidste.
     Produktbilledet staar altid foerst. */
  function imagesForColor(color) {
    var product = state.product;
    if (state.colorIndex < 0 || !color) return allImages();
    /* Kun een farve: alle egne billeder er den farve. */
    if (product.options[state.colorIndex].values.length < 2) return allImages();

    var picked = mediaForColorAndStyle(color);
    if (picked.some(function (item) { return referencesProduct(item.alt); })) {
      return toImages(leadWithProduct(picked));
    }

    var needle = String(color).toLowerCase();
    var byFile = (product.media || []).filter(function (item) {
      if (!usable(item) || isLifestyle(item.alt) || isForeign(item.alt)) return false;
      return imageKey(item.preview_image.src).indexOf(needle) !== -1;
    });
    if (byFile.length) return toImages(leadWithProduct(byFile));

    var byVariant = product.variants.reduce(function (list, variant) {
      var image = variant.featured_image;
      if (optionValue(variant, state.colorIndex) !== color) return list;
      if (!image || !image.src || isLifestyle(image.alt) || isForeign(image.alt)) return list;
      return list.concat([{ preview_image: { src: image.src }, alt: image.alt || '' }]);
    }, []);
    if (byVariant.length) return toImages(byVariant);

    return allImages();
  }

  /* Desktop only (CSS hides them on touch): scroll the thumb row one step. */
  function addImageArrows(row) {
    ['prev', 'next'].forEach(function (dir) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'twrd-qa__arrow twrd-qa__arrow--' + dir;
      button.setAttribute('aria-label', dir === 'prev' ? 'Previous images' : 'Next images');
      button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="square" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
      button.addEventListener('click', function () {
        var thumb = row.querySelector('.twrd-qa__thumb');
        var step = thumb ? thumb.getBoundingClientRect().width + 8 : row.clientWidth;
        row.scrollBy({ left: dir === 'prev' ? -step : step, behavior: reducedMotion() ? 'auto' : 'smooth' });
      });
      row.appendChild(button);
    });
  }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Hovedbilledet skifter til thumb nummer index. */
  function showMain(index) {
    var item = state.images[index];
    if (!item) return;
    state.imageIndex = index;
    yieldQueue();
    showVideo(item);
    el.mainImg.sizes = MAIN_SIZES;
    el.mainImg.srcset = mainSrcset(item.src);
    el.mainImg.src = sized(item.src, 1100);
    /* Pin-markoeren (" #2" sidst i alt) styrer PDP-galleriets raekkefoelge.
       Den maa ikke vises. Samme regel som snippets/twrd-alt-clean.liquid. */
    el.mainImg.alt = String(item.alt || '').replace(/\s*#[1-9]\d?\s*$/, '') || state.product.title;
    Array.prototype.forEach.call(el.images.querySelectorAll('[data-twrd-qa-thumb]'), function (thumb) {
      var on = thumb.getAttribute('data-twrd-qa-thumb') === String(index);
      thumb.classList.toggle('is-active', on);
      thumb.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    pump();
  }

  /* Videoen hentes foerst naar kunden vaelger dens thumb. Foer det findes
     kun posteren. Et andet billede pauser den. */
  function videoEl() {
    if (el.mainVideo) return el.mainVideo;
    var video = document.createElement('video');
    video.className = 'twrd-qa__mainvideo';
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('preload', 'none');
    video.hidden = true;
    el.mainVideo = video;
    /* Pause og play oppe i hjoernet, samme stil som PDP-galleriet. Et span,
       for paa telefon ligger videoen inde i thumb-knappen. */
    var toggle = document.createElement('span');
    toggle.className = 'twrd-qa__vtoggle';
    toggle.setAttribute('role', 'button');
    toggle.setAttribute('tabindex', '0');
    toggle.hidden = true;
    toggle.innerHTML = '<svg class="twrd-qa__ico-pause" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg><svg class="twrd-qa__ico-play" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4.5 19 12 7 19.5z"/></svg>';
    var flip = function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (video.paused) {
        var played = video.play();
        if (played && played.catch) played.catch(function () {});
      } else {
        video.pause();
      }
    };
    toggle.addEventListener('click', flip);
    toggle.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') flip(event);
    });
    var sync = function () {
      toggle.setAttribute('data-state', video.paused ? 'paused' : 'playing');
      toggle.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    };
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    sync();
    el.videoToggle = toggle;
    return video;
  }

  /* Desktop: over hovedbilledet. Telefon skjuler hovedbilledet, saa videoen
     spiller i sin egen thumb i raekken. */
  function videoHost() {
    var main = el.mainImg.parentNode;
    if (main.offsetParent !== null) return main;
    return el.images.querySelector('.twrd-qa__thumb--video') || main;
  }

  function showVideo(item) {
    if (!item.video) {
      if (el.mainVideo) {
        el.mainVideo.pause();
        el.mainVideo.hidden = true;
        el.videoToggle.hidden = true;
      }
      return;
    }
    var video = videoEl();
    var host = videoHost();
    if (video.parentNode !== host) {
      host.appendChild(video);
      host.appendChild(el.videoToggle);
    }
    el.videoToggle.hidden = false;
    video.poster = sized(item.src, 1100);
    video.controls = reducedMotion();
    if (video.getAttribute('src') !== item.video) video.src = item.video;
    video.hidden = false;
    if (reducedMotion()) return;
    var played = video.play();
    if (played && played.catch) played.catch(function () { video.controls = true; });
  }

  function clearVideo() {
    if (!el.mainVideo) return;
    el.mainVideo.pause();
    el.mainVideo.removeAttribute('src');
    el.mainVideo.removeAttribute('poster');
    el.mainVideo.load();
    el.mainVideo.hidden = true;
    el.videoToggle.hidden = true;
  }

  function renderImages() {
    var images = imagesForColor(state.selectedColor);
    var clip = videoForColor(state.selectedColor);
    if (images.length && clip) images = images.concat([clip]);
    clearVideo();
    state.images = images;
    el.images.textContent = '';
    el.images.scrollLeft = 0;
    if (!images.length) {
      el.media.hidden = true;
      return;
    }
    images.forEach(function (item, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'twrd-qa__thumb';
      button.setAttribute('data-twrd-qa-thumb', String(index));
      button.setAttribute('aria-label', item.video ? 'Play video' : 'Show image ' + (index + 1) + ' of ' + images.length);
      if (item.video) {
        button.classList.add('twrd-qa__thumb--video');
        var play = document.createElement('span');
        play.className = 'twrd-qa__play';
        play.setAttribute('aria-hidden', 'true');
        play.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4.5 19 12 7 19.5z"/></svg>';
        button.appendChild(play);
      }
      var img = document.createElement('img');
      img.className = 'twrd-qa__img';
      img.loading = index < THUMBS_VISIBLE ? 'eager' : 'lazy';
      img.alt = '';
      img.src = sized(item.src, 300);
      img.srcset = thumbSrcset(item.src);
      img.sizes = THUMB_SIZES;
      button.appendChild(img);
      el.images.appendChild(button);
    });
    /* More than four: the fifth thumb peeks in at the right edge (CSS). */
    el.images.classList.toggle('is-many', images.length > THUMBS_VISIBLE);
    if (images.length > THUMBS_VISIBLE) addImageArrows(el.images);
    showMain(0);
    el.media.hidden = false;
    queueForSheet();
  }

  /* ---------- sibling products ---------- */

  /* "handle|label|swatch;..." from snippets/twrd-sibling-data.liquid. */
  function parseGroup(text) {
    return String(text || '').split(';').map(function (entry) {
      var parts = entry.split('|');
      return { handle: (parts[0] || '').trim(), label: (parts[1] || '').trim(), swatch: (parts[2] || '').trim() };
    }).filter(function (entry) { return entry.handle; });
  }

  function groupHas(group, handle) {
    return group.some(function (entry) { return entry.handle === handle; });
  }

  /* A group counts when it holds the shown product and at least one other. */
  function activeGroup(group) {
    return state.product && group.length > 1 && groupHas(group, state.product.handle) ? group : null;
  }

  /* Groups for a handle: its own card button on the page first, else the
     current group when it holds the handle. */
  function groupsFor(handle, trigger) {
    var source = trigger && trigger.getAttribute && trigger.getAttribute('data-twrd-quickadd') === handle ? trigger : null;
    if (!source && window.CSS && CSS.escape) {
      source = document.querySelector('[data-twrd-quickadd="' + CSS.escape(handle) + '"]');
    }
    var colours = source ? parseGroup(source.getAttribute('data-twrd-colours')) : [];
    var editions = source ? parseGroup(source.getAttribute('data-twrd-editions')) : [];
    if (!colours.length && groupHas(state.colourGroup, handle)) colours = state.colourGroup;
    if (!editions.length && groupHas(state.editionGroup, handle)) editions = state.editionGroup;
    return { colours: colours, editions: editions };
  }

  function siblingButton(entry, kind) {
    var button = document.createElement('button');
    var current = entry.handle === state.product.handle;
    button.type = 'button';
    button.className = 'twrd-qa__swatch twrd-qa__swatch--sibling';
    if (/^#[0-9a-f]{3,8}$/i.test(entry.swatch)) {
      button.style.backgroundColor = entry.swatch;
    } else if (entry.swatch) {
      button.classList.add('twrd-qa__swatch--img', 'twrd-qa__swatch--tile');
      button.style.backgroundImage = 'url("' + entry.swatch.replace(/["\\]/g, '') + '")';
    } else {
      button.style.backgroundColor = '#8a8a8a';
    }
    /* No title: the row label shows the name on hover, like the PDP. */
    button.setAttribute('data-twrd-name', entry.label);
    button.setAttribute('aria-label', (kind === 'edition' ? 'Edition ' : 'Colour ') + entry.label);
    button.setAttribute('data-twrd-qa-sibling', entry.handle);
    button.setAttribute('aria-pressed', current ? 'true' : 'false');
    if (current) button.classList.add('is-selected');
    return button;
  }

  function labelIn(group) {
    var own = group.filter(function (entry) { return entry.handle === state.product.handle; })[0];
    return own ? own.label : '';
  }

  /* Row label with the current name kept aside, so hover can restore it. */
  function setRowLabel(label, text) {
    label.textContent = text;
    label.setAttribute('data-twrd-current', text);
  }

  /* Hover or focus on a sibling swatch shows its name in the row label;
     leaving restores the current name. Same logic as assets/twrd-swatch-hover.js
     on the PDP, bound by delegation because the rows are rebuilt on every swap. */
  function siblingLabel(button) {
    var group = button.closest('.twrd-qa__group');
    return group ? group.querySelector('.twrd-qa__labelvalue') : null;
  }

  function onSiblingEnter(event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-twrd-qa-sibling]') : null;
    var label = button && siblingLabel(button);
    var name = button && button.getAttribute('data-twrd-name');
    if (label && name) label.textContent = name;
  }

  function onSiblingLeave(event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-twrd-qa-sibling]') : null;
    if (!button || (event.relatedTarget && button.contains(event.relatedTarget))) return;
    var label = siblingLabel(button);
    if (label && label.hasAttribute('data-twrd-current')) label.textContent = label.getAttribute('data-twrd-current');
  }

  function renderEditions() {
    if (!el.editions) return;
    var group = activeGroup(state.editionGroup);
    if (!group) {
      el.editions.hidden = true;
      return;
    }
    setRowLabel(el.editionLabel, labelIn(group));
    el.editionTiles.textContent = '';
    group.forEach(function (entry) { el.editionTiles.appendChild(siblingButton(entry, 'edition')); });
    el.editions.hidden = false;
  }

  /* Swap the whole sheet to a sibling product. The sheet stays open. */
  function swapTo(handle) {
    if (!state.product || handle === state.product.handle || state.busy) return;
    var token = state.swapToken + 1;
    state.swapToken = token;
    el.root.classList.add('is-swapping');
    fetchProduct(handle)
      .then(function (product) {
        if (el.root.hidden || state.swapToken !== token) return;
        var groups = groupsFor(handle, null);
        window.clearTimeout(nudgeTimer);
        el.sizeWrap.classList.remove('is-nudged');
        el.error.hidden = true;
        el.error.textContent = '';
        resetSignup();
        state.phase = 'idle';
        state.colourGroup = groups.colours;
        state.editionGroup = groups.editions;
        prepare(product, null);
        /* The card flag belongs to the card product, so only the tag counts here. */
        state.upcoming = isUpcoming(product, null);
        render();
      })
      .catch(function (error) {
        if (state.swapToken !== token) return;
        el.error.hidden = false;
        el.error.textContent = 'Could not load this colour. Please try again.';
        if (window.console) console.warn('twrd-quick-add: sibling fetch failed', error);
      })
      .then(function () {
        if (state.swapToken === token) el.root.classList.remove('is-swapping');
      });
  }

  function renderSwatches() {
    var siblings = activeGroup(state.colourGroup);
    /* PDP style (Oliver 2026-10-21): every colour row shows only the name.
       "Colour: " stays for screen readers. */
    el.colors.classList.add('is-name-only');
    if (siblings) {
      el.colorName.textContent = 'Colour: ';
      setRowLabel(el.colorLabel, labelIn(siblings));
      el.swatches.textContent = '';
      siblings.forEach(function (entry) { el.swatches.appendChild(siblingButton(entry, 'colour')); });
      el.colors.hidden = false;
      return;
    }
    if (state.colorIndex < 0) {
      el.colors.hidden = true;
      return;
    }
    var option = state.product.options[state.colorIndex];
    el.colorName.textContent = (matchName(option.name, COLOUR_NAMES) ? 'Colour' : option.name) + ': ';
    el.colorLabel.textContent = state.selectedColor || '';
    el.swatches.textContent = '';
    /* One colour and no siblings: the product photo as a 4:5 tile, like the PDP. */
    var photo = option.values.length === 1 && state.product.featured_image;
    if (photo) {
      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'twrd-qa__swatch twrd-qa__swatch--img twrd-qa__swatch--tile is-selected';
      tile.style.backgroundImage = 'url("' + sized(photo, 120).replace(/["\\]/g, '') + '")';
      tile.setAttribute('aria-label', option.name + ' ' + option.values[0]);
      tile.setAttribute('data-twrd-qa-color', option.values[0]);
      tile.setAttribute('aria-pressed', 'true');
      el.swatches.appendChild(tile);
      el.colors.hidden = false;
      return;
    }
    option.values.forEach(function (value) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'twrd-qa__swatch';
      var hex = colourFor(value);
      button.style.backgroundColor = hex || '#8a8a8a';
      if (!hex || hex === '#f2f2f2') button.style.borderColor = 'rgba(10,9,8,0.35)';
      button.title = value;
      button.setAttribute('aria-label', option.name + ' ' + value);
      button.setAttribute('data-twrd-qa-color', value);
      button.setAttribute('aria-pressed', value === state.selectedColor ? 'true' : 'false');
      if (value === state.selectedColor) button.classList.add('is-selected');
      el.swatches.appendChild(button);
    });
    el.colors.hidden = false;
  }

  /* Tile image per Style, same rules as the PDP style thumbs:
     front = colour + view front without "edition";
     back = colour + "back print edition" + view back, else colour + view back.
     View comes from viewFromAlt (last "front print" / "back print" segment). */
  function styleThumb(color, value) {
    var all = state.colorIndex >= 0 && color ? mediaForColor(color) : (state.product.media || []).filter(function (item) {
      return item.preview_image && item.preview_image.src && !isLifestyle(item.alt);
    });
    var pick = null;
    if (styleIsBack(value)) {
      pick = all.filter(function (item) {
        return isBackEdition(item.alt) && viewFromAlt(item.alt) === 'back';
      })[0] || all.filter(function (item) {
        return !isBackEdition(item.alt) && viewFromAlt(item.alt) === 'back';
      })[0];
    } else {
      pick = all.filter(function (item) {
        return !isBackEdition(item.alt) && viewFromAlt(item.alt) === 'front';
      })[0];
    }
    pick = pick || all[0];
    return pick ? pick.preview_image.src : null;
  }

  function styleLabel(value) {
    var lower = String(value || '').toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  }

  function renderStyles() {
    if (state.styleIndex < 0) {
      el.styles.hidden = true;
      return;
    }
    var values = state.product.options[state.styleIndex].values;
    el.styleLabel.textContent = styleLabel(state.selectedStyle);
    el.styleTiles.textContent = '';
    values.forEach(function (value) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'twrd-qa__style';
      button.setAttribute('data-twrd-qa-style', value);
      button.setAttribute('aria-label', 'Style ' + styleLabel(value));
      button.setAttribute('aria-pressed', value === state.selectedStyle ? 'true' : 'false');
      if (value === state.selectedStyle) button.classList.add('is-selected');
      var thumb = document.createElement('span');
      thumb.className = 'twrd-qa__stylethumb' + (styleIsBack(value) ? ' twrd-qa__stylethumb--back' : '');
      var src = styleThumb(state.selectedColor, value);
      if (src) thumb.style.backgroundImage = 'url("' + String(src).replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') + '")';
      var caption = document.createElement('span');
      caption.className = 'twrd-qa__stylecaption';
      caption.textContent = styleLabel(value);
      button.appendChild(thumb);
      button.appendChild(caption);
      el.styleTiles.appendChild(button);
    });
    el.styles.hidden = false;
  }

  function renderSizes() {
    if (state.sizeIndex < 0) {
      el.sizeWrap.hidden = true;
      return;
    }
    var values = state.product.options[state.sizeIndex].values;
    el.sizeLabel.textContent = state.selectedSize || '';
    el.sizeSep.hidden = !state.selectedSize;
    el.sizes.textContent = '';
    /* One size only (caps): the label already says it, so no chip to tap. */
    var single = values.length === 1 && !!state.selectedSize;
    el.sizes.hidden = single;
    if (single) {
      el.sizeWrap.hidden = false;
      return;
    }
    values.forEach(function (value) {
      var match = resolve(state.selectedColor, value);
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'twrd-qa__size';
      button.setAttribute('data-twrd-qa-size', value);
      button.setAttribute('data-tw-ls', '1');
      var label = document.createElement('span');
      label.setAttribute('data-tw-ls', '1');
      label.textContent = value;
      if (!match.variant || !match.available) {
        button.classList.add('twrd-qa__size--out');
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-label', 'Size ' + value + ' sold out');
        button.innerHTML = STRIKE_SVG + MAIL_SVG;
        button.appendChild(label);
      } else {
        button.appendChild(label);
        if (value === state.selectedSize) {
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
        } else {
          button.setAttribute('aria-pressed', 'false');
        }
      }
      el.sizes.appendChild(button);
    });
    el.sizeWrap.hidden = false;
  }

  /* Every <p class="p2"> line of the description, whitespace normalised.
     Returns a new array, the input html is never touched. */
  function verseLines(html) {
    try {
      var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
      return Array.prototype.map.call(doc.querySelectorAll('p.p2'), function (node) {
        return (node.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
      }).filter(Boolean);
    } catch (_) {
      return [];
    }
  }

  /* The reference is always the LAST p.p2 line ("2 Timothy 1:7", dash stripped).
     Every earlier p2 line is verse text, joined with a space, so a verse that
     runs over two paragraphs keeps both paragraphs. Zero or one line means no
     verse. Same semantics as verseFrom() in the chat widget. */
  function verseFrom(html) {
    var lines = verseLines(html);
    if (lines.length < 2) return null;
    var ref = lines[lines.length - 1].replace(/^[\u2014\u2013-]\s*/, '').trim();
    var text = lines.slice(0, -1).join(' ').trim();
    if (!text || !ref) return null;
    if (ref.indexOf(':') === -1 || ref.length > VERSE_MAX_REF_LEN) return null;
    return {
      text: text.replace(/^[\u201c"]/, '').replace(/[\u201d"]$/, '').trim(),
      ref: ref
    };
  }

  /* Eyebrow over titlen: "The Word · Tee". Typen i ental, t-shirt hedder tee. */
  function kindLabel(type) {
    var lower = String(type || '').toLowerCase();
    if (/t-?shirt|\btees?\b/.test(lower)) return 'Tee';
    if (/hoodie/.test(lower)) return 'Hoodie';
    return String(type || '').replace(/s$/i, '').trim();
  }

  /* "Ships by Wed 30 Sep" fra samme regel som PDP og kurv. Ingen hjaelper
     (eller en fejl): segmentet skjules. */
  function renderShip() {
    var text = '';
    try {
      var delivery = window.TWRDDelivery;
      var plan = delivery && delivery.schedule ? delivery.schedule({}) : null;
      if (plan && plan.shipTo) text = DAYS[plan.shipTo.getDay()] + ' ' + delivery.formatDate(plan.shipTo);
    } catch (error) {
      if (window.console) console.warn('twrd-quick-add: ship date failed', error);
      text = '';
    }
    el.shipDate.textContent = text;
    el.ship.hidden = !text;
    el.shipDot.hidden = !text;
  }

  /* Caps (no verse): the plain <p> lines of the description. The last line is
     the spec ("Structured six-panel cap in 100% cotton. ... One size."), split
     into short facts. The lines before it are the story about the word. */
  function capCopyFrom(product) {
    if (!/cap/i.test(String(product.type || ''))) return null;
    try {
      var doc = new DOMParser().parseFromString(String(product.description || ''), 'text/html');
      var lines = Array.prototype.filter.call(doc.querySelectorAll('p'), function (node) {
        return !node.classList.contains('p1') && !node.classList.contains('p2');
      }).map(function (node) {
        return (node.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
      }).filter(Boolean);
      if (lines.length < 2) return null;
      var spec = lines[lines.length - 1];
      var facts = spec.split(/\.\s+/).map(function (part) {
        return part.replace(/\.$/, '').trim();
      }).filter(Boolean).map(function (fact) {
        /* The size line already says one size. Give the range instead (supplier spec). */
        return /^one size$/i.test(fact) ? 'Snapback adjusts from 57 to 59 cm' : fact;
      });
      facts.push('Crown logo on the left side panel');
      return { story: lines.slice(0, -1).join(' '), facts: facts };
    } catch (_) {
      return null;
    }
  }

  function renderCapCopy(product, hasVerse) {
    var copy = hasVerse ? null : capCopyFrom(product);
    el.story.hidden = !copy;
    el.story.textContent = copy ? copy.story : '';
    el.factList.textContent = '';
    if (copy) {
      copy.facts.forEach(function (fact) {
        var li = document.createElement('li');
        li.textContent = fact;
        el.factList.appendChild(li);
      });
    }
    el.facts.hidden = !copy || !copy.facts.length;
  }

  /* Fact grid under the CTA (2026-10-30). Mirrors snippets/twrd-pdp-facts.liquid
     with only what /products/<handle>.js gives: type, title and tags. Caps keep
     their own "The cap" block. Unknown types get no grid. */
  function gridFactsFor(product) {
    var type = String(product.type || '').toLowerCase();
    var hay = type + ' ' + String(product.title || '').toLowerCase();
    if (/cap/.test(type)) return null;
    if (/sweatpant|jogger/.test(hay)) {
      return [
        ['Heavyweight fleece', '100% combed cotton, pre-shrunk'],
        ['Oversized fit', 'Elastic waist and cuffs']
      ];
    }
    if (/hoodie|sweatshirt/.test(hay)) {
      if (/sweatshirt/.test(hay)) {
        return [
          ['Combed cotton', 'Pre-shrunk, reactive-dyed'],
          ['Loose fit', 'Drop shoulder, true to size']
        ];
      }
      return [
        ['Heavyweight fleece', '100% combed cotton, pre-shrunk'],
        ['Oversized fit', 'Drop shoulder, true to size']
      ];
    }
    if (/t-?shirt|\btees?\b/.test(type)) {
      var gsm = '';
      (product.tags || []).some(function (tag) {
        var m = /^gsm-(\d{3})$/i.exec(String(tag).trim());
        if (m) gsm = m[1];
        return !!m;
      });
      return [
        [gsm ? gsm + ' gsm cotton' : 'Heavyweight cotton', 'Combed cotton, pre-shrunk'],
        ['Oversized fit', 'Drop shoulder, true to size']
      ];
    }
    return null;
  }

  function renderGrid(product) {
    if (!el.grid) return;
    var facts = gridFactsFor(product);
    el.grid.textContent = '';
    (facts || []).forEach(function (fact) {
      var li = document.createElement('li');
      li.className = 'twrd-qa__spec';
      var title = document.createElement('b');
      title.setAttribute('data-tw-ls', '1');
      title.textContent = fact[0];
      li.appendChild(title);
      li.appendChild(span(fact[1]));
      el.grid.appendChild(li);
    });
    el.grid.hidden = !facts;
  }

  function renderInfo() {
    var product = state.product;
    el.eyebrow.textContent = [product.vendor || 'The Word', kindLabel(product.type)].filter(Boolean).join(' · ');
    var verse = verseFrom(product.description);
    el.verse.hidden = !verse;
    el.verseText.textContent = verse ? verse.text : '';
    el.verseRef.textContent = verse ? verse.ref : '';
    renderCapCopy(product, !!verse);
    renderGrid(product);
    el.sizeLink.href = product.url + '#size-guide';
    el.link.href = product.url;
    renderShip();
  }

  function renderPrice() {
    var match = resolve(state.selectedColor, state.selectedSize);
    var price = match.variant ? match.variant.price : state.product.price;
    el.price.textContent = money(price);
  }

  function needsSize() {
    return state.sizeIndex >= 0 && state.product.options[state.sizeIndex].values.length > 1 && !state.selectedSize;
  }

  function span(text, className) {
    var node = document.createElement('span');
    node.setAttribute('data-tw-ls', '1');
    if (className) node.className = className;
    node.textContent = text;
    return node;
  }

  /* CTA-tilstande: select (ingen stoerrelse), ready, soldout, adding, added. */
  function addMode() {
    if (state.upcoming) return 'upcoming';
    if (state.phase === 'adding' || state.phase === 'added') return state.phase;
    if (needsSize()) return 'select';
    var match = resolve(state.selectedColor, state.selectedSize);
    return match.variant && match.available ? 'ready' : 'soldout';
  }

  function renderAdd() {
    var mode = addMode();
    var match = resolve(state.selectedColor, state.selectedSize);
    el.add.className = 'twrd-qa__add twrd-qa__add--' + mode;
    el.add.disabled = mode === 'soldout';
    el.add.setAttribute('aria-disabled', mode === 'ready' || mode === 'select' || mode === 'upcoming' ? 'false' : 'true');
    el.add.setAttribute('aria-busy', mode === 'adding' ? 'true' : 'false');
    el.add.textContent = '';
    if (mode === 'upcoming') {
      el.add.appendChild(span('Notify me'));
    } else if (mode === 'ready') {
      el.add.appendChild(span('Add to bag'));
      el.add.appendChild(span('·', 'twrd-qa__adddot'));
      el.add.appendChild(span(money(match.variant.price)));
    } else if (mode === 'select') {
      el.add.appendChild(span('Select a size'));
    } else if (mode === 'adding') {
      el.add.appendChild(span('Adding …'));
    } else if (mode === 'added') {
      el.add.insertAdjacentHTML('beforeend', CHECK_SVG);
      el.add.appendChild(span('Added'));
    } else {
      el.add.appendChild(span('Sold out'));
    }
  }

  /* "Select a size": raekken med stoerrelser markeres kort. Tastatur faar
     fokus paa foerste ledige stoerrelse. Rystet kun uden reduced motion (CSS). */
  var nudgeTimer = null;

  function nudgeSizes(fromKeyboard) {
    window.clearTimeout(nudgeTimer);
    el.sizeWrap.classList.remove('is-nudged');
    void el.sizeWrap.offsetWidth;
    el.sizeWrap.classList.add('is-nudged');
    nudgeTimer = window.setTimeout(function () {
      el.sizeWrap.classList.remove('is-nudged');
    }, NUDGE_MS);
    if (el.sizeWrap.scrollIntoView) {
      el.sizeWrap.scrollIntoView({ block: 'nearest', behavior: reducedMotion() ? 'auto' : 'smooth' });
    }
    if (fromKeyboard) {
      var first = el.sizes.querySelector('.twrd-qa__size:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    }
  }

  function render() {
    el.loading.hidden = true;
    el.failed.hidden = true;
    el.content.hidden = false;
    el.title.textContent = state.product.title;
    renderImages();
    renderEditions();
    renderSwatches();
    renderStyles();
    renderSizes();
    renderInfo();
    renderPrice();
    renderAdd();
    if (el.micro) el.micro.hidden = state.upcoming;
  }

  /* ---------- upcoming sign-up ---------- */

  var UP_TAG = 'twrd-upcoming';

  /* Tag in /products/<handle>.js, the handles the cart guard knows
     (snippets/twrd-upcoming-guard.liquid), or the flag on the card button. */
  function isUpcoming(product, trigger) {
    if ((product.tags || []).indexOf(UP_TAG) !== -1) return true;
    var known = window.twrdUpcoming && window.twrdUpcoming.handles;
    if (known && known.indexOf(product.handle) !== -1) return true;
    return !!(trigger && trigger.getAttribute && trigger.getAttribute('data-twrd-upcoming') === '1');
  }

  function resetSignup() {
    if (!el.up) return;
    el.up.hidden = true;
    el.up.classList.remove('is-done');
    el.add.hidden = false;
    if (el.upForm) el.upForm.reset();
    if (el.upError) { el.upError.hidden = true; el.upError.textContent = ''; }
    if (el.upDone) el.upDone.hidden = true;
    if (el.upSubmit) el.upSubmit.disabled = false;
    if (el.micro) el.micro.hidden = false;
  }

  /* "Coming soon" turns into the email field. Never an add to cart. */
  function openSignup() {
    if (!el.up || !el.upForm || !state.product) {
      /* No form on this page: the PDP has the same sign-up. */
      if (state.product) window.location.href = state.product.url + '#sign-up';
      return;
    }
    el.upTags.value = 'upcoming,upcoming-' + state.product.handle;
    el.add.hidden = true;
    el.up.hidden = false;
    if (el.upEmail) el.upEmail.focus({ preventScroll: true });
    if (el.up.scrollIntoView) el.up.scrollIntoView({ block: 'nearest' });
  }

  function signupError(text) {
    el.upError.textContent = text;
    el.upError.hidden = false;
    el.upSubmit.disabled = false;
  }

  /* Post the customer form in the background, so the sheet stays open.
     Shopify answers a good post with a redirect to ?customer_posted=true.
     A bot challenge needs the real page, so then the form posts natively. */
  function submitSignup(event) {
    event.preventDefault();
    if (!state.product || !state.upcoming) return;
    el.upError.hidden = true;
    var email = (el.upEmail.value || '').trim();
    el.upEmail.value = email;
    if (!email || !el.upEmail.checkValidity()) {
      signupError('Check the email address and try again.');
      el.upEmail.focus({ preventScroll: true });
      return;
    }
    el.upTags.value = 'upcoming,upcoming-' + state.product.handle;
    el.upSubmit.disabled = true;
    fetch(el.upForm.action, {
      method: 'POST',
      body: new FormData(el.upForm),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        var url = response.url || '';
        if (url.indexOf('/challenge') !== -1) {
          el.upForm.removeEventListener('submit', submitSignup);
          el.upForm.submit();
          return;
        }
        if (response.ok && url.indexOf('customer_posted=true') !== -1) {
          el.up.classList.add('is-done');
          el.upDone.hidden = false;
          el.upSubmit.disabled = false;
          return;
        }
        signupError('Check the email address and try again.');
      })
      .catch(function (error) {
        signupError('Could not sign you up. Please try again.');
        if (window.console) console.warn('twrd-quick-add: sign-up failed', error);
      });
  }

  /* ---------- open / close ---------- */

  var lastFocus = null;
  var lastDialog = null;

  function focusable() {
    return Array.prototype.filter.call(
      el.sheet.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (node) {
        return node.offsetWidth > 0 || node.offsetHeight > 0;
      }
    );
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var nodes = focusable();
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function close(fast) {
    if (el.root.hidden) return;
    queueReset();
    if (fast) el.root.classList.add('twrd-qa--fast');
    el.root.classList.remove('is-open');
    document.removeEventListener('keydown', onKeydown, true);
    document.body.classList.remove('twrd-qa-locked');
    window.setTimeout(function () {
      el.root.hidden = true;
      el.root.classList.remove('twrd-qa--fast');
    }, fast ? FAST_CLOSE_MS : 200);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    keepFocusIn(lastDialog);
    lastFocus = null;
    lastDialog = null;
  }

  /* Kortet forsvinder fra kurv-skuffen, naar varen er lagt i kurven: skuffen
     tegner sig selv igen lidt efter. Fokus falder saa til <body>, og Esc og
     Tab virker ikke laengere i skuffen. Vi flytter fokus tilbage til skuffen,
     hvis den stadig er aaben. */
  function keepFocusIn(dialog) {
    if (!dialog) return;
    function check() {
      var active = document.activeElement;
      if (active && active !== document.body && document.contains(active)) return;
      if (!document.contains(dialog) || dialog.getAttribute('aria-hidden') === 'true') return;
      dialog.focus({ preventScroll: true });
    }
    [0, 400, 1200, 2500].forEach(function (ms) { window.setTimeout(check, ms); });
  }

  function reset() {
    window.clearTimeout(addedTimer);
    window.clearTimeout(nudgeTimer);
    state.product = null;
    state.busy = false;
    state.phase = 'idle';
    state.images = [];
    clearVideo();
    el.loading.hidden = false;
    el.failed.hidden = true;
    el.content.hidden = true;
    el.media.hidden = true;
    el.images.textContent = '';
    /* srcset too, or the last product's photo stays on the next open. */
    el.mainImg.removeAttribute('srcset');
    el.mainImg.removeAttribute('src');
    el.colors.hidden = true;
    if (el.editions) el.editions.hidden = true;
    el.root.classList.remove('is-swapping');
    state.swapToken += 1;
    state.colourGroup = [];
    state.editionGroup = [];
    el.styles.hidden = true;
    el.sizeWrap.hidden = true;
    el.sizeWrap.classList.remove('is-nudged');
    el.verse.hidden = true;
    el.story.hidden = true;
    el.facts.hidden = true;
    if (el.grid) {
      el.grid.hidden = true;
      el.grid.textContent = '';
    }
    el.eyebrow.textContent = '';
    el.title.textContent = '';
    el.price.textContent = '';
    el.error.hidden = true;
    el.error.textContent = '';
    el.add.disabled = true;
    state.upcoming = false;
    resetSignup();
    if (el.body) el.body.scrollTop = 0;
  }

  function prepare(product, preferredId) {
    state.product = product;
    state.colorIndex = -1;
    state.sizeIndex = -1;
    state.styleIndex = -1;
    state.otherIndexes = [];
    (product.options || []).forEach(function (option, index) {
      if (matchName(option.name, SIZE_NAMES)) state.sizeIndex = index;
      else if (matchName(option.name, COLOUR_NAMES)) state.colorIndex = index;
      else if (matchName(option.name, STYLE_NAMES)) state.styleIndex = index;
      else state.otherIndexes.push(index);
    });

    var preferred = variantById(product, preferredId);
    if (!preferred) {
      preferred = product.variants.filter(function (variant) {
        return variant.available;
      })[0] || product.variants[0] || null;
    }
    state.preferred = preferred;

    state.selectedColor = null;
    if (state.colorIndex >= 0) {
      state.selectedColor = preferred ? optionValue(preferred, state.colorIndex) : null;
      if (!state.selectedColor) {
        var firstAvailable = product.variants.filter(function (variant) {
          return variant.available;
        })[0];
        state.selectedColor = firstAvailable
          ? optionValue(firstAvailable, state.colorIndex)
          : product.options[state.colorIndex].values[0];
      }
    }

    state.selectedStyle = null;
    if (state.styleIndex >= 0) {
      state.selectedStyle = (preferred && optionValue(preferred, state.styleIndex)) ||
        product.options[state.styleIndex].values[0];
    }

    state.selectedSize = null;
    if (state.sizeIndex >= 0 && product.options[state.sizeIndex].values.length === 1) {
      state.selectedSize = product.options[state.sizeIndex].values[0];
    }
  }

  function productRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fetchProduct(handle) {
    if (CACHE[handle]) return Promise.resolve(CACHE[handle]);
    if (PENDING[handle]) return PENDING[handle];
    PENDING[handle] = fetch(productRoot() + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (product) {
        CACHE[handle] = product;
        delete PENDING[handle];
        return product;
      }, function (error) {
        /* A failed fetch must not stick: the next click tries again. */
        delete PENDING[handle];
        throw error;
      });
    return PENDING[handle];
  }

  /* ---------- warm on intent ---------- */

  /* The images open() will show, without touching the open sheet. prepare()
     writes to state, so state is restored right after. */
  function pickImages(product, preferredId) {
    return withState({}, function () {
      prepare(product, preferredId);
      return imagesForColor(state.selectedColor);
    });
  }

  function preload(src, srcset, sizes, high) {
    var img = new Image();
    if (high && 'fetchPriority' in img) img.fetchPriority = 'high';
    img.decoding = 'async';
    img.sizes = sizes;
    img.srcset = srcset;
    img.src = src;
  }

  /* Hover, focus or touch on the bag button: load the JSON and the first
     images now, so the click only has to paint. Never the whole grid. */
  function warm(trigger) {
    var handle = trigger.getAttribute('data-twrd-quickadd');
    if (!handle || WARMED[handle]) return;
    WARMED[handle] = true;
    fetchProduct(handle)
      .then(function (product) {
        /* Clicked already: open() sets its own images. */
        if (!el.root.hidden) return;
        var images = pickImages(product, trigger.getAttribute('data-twrd-variant'));
        images.slice(0, THUMBS_VISIBLE).forEach(function (item, index) {
          if (index === 0) preload(sized(item.src, 1100), mainSrcset(item.src), MAIN_SIZES, true);
          preload(sized(item.src, 300), thumbSrcset(item.src), THUMB_SIZES, false);
        });
      })
      .catch(function () {
        WARMED[handle] = false;
      });
  }

  /* ---------- preload queue in the open sheet ---------- */

  /* Every thumb, Style and colour click should paint at once. The large
     images load in the background, one at a time and at low priority, so
     the image on screen is never starved. A new open or a close bumps the
     generation, and the old queue stops. */
  var queue = { gen: 0, list: [], seen: {}, started: 0, current: null, wanted: null, waiting: false };

  /* Close or a new product: cancel the load in flight, start a new generation. */
  function queueReset() {
    cancelCurrent();
    queue = { gen: queue.gen + 1, list: [], seen: {}, started: 0, current: null, wanted: null, waiting: false };
  }

  function queueKey(item) {
    return item.tile + ':' + imageKey(item.src);
  }

  function loadImage(item, priority, done) {
    var img = new Image();
    if ('fetchPriority' in img) img.fetchPriority = priority;
    img.decoding = 'async';
    if (done) img.onload = img.onerror = done;
    if (item.tile) {
      img.src = sized(item.src, 300);
    } else {
      img.sizes = MAIN_SIZES;
      img.srcset = mainSrcset(item.src);
      img.src = sized(item.src, 1100);
    }
    return img;
  }

  /* Emptying src makes the browser drop the request. */
  function cancelCurrent() {
    var current = queue.current;
    if (!current) return null;
    queue.current = null;
    if (current.img.complete) return null;
    current.img.onload = current.img.onerror = null;
    current.img.removeAttribute('srcset');
    current.img.src = '';
    return current.item;
  }

  /* The user asked for an image: the background load in flight steps aside
     so the two do not share the line. It goes back to the front of the queue. */
  function yieldQueue() {
    var item = cancelCurrent();
    if (!item) return;
    queue.started -= 1;
    queue.seen[queueKey(item)] = 'queued';
    queue.list = [item].concat(queue.list);
  }

  function enqueue(src, tile) {
    if (!src) return;
    var item = { src: src, tile: !!tile };
    var key = queueKey(item);
    if (queue.seen[key]) return;
    if (queue.started + queue.list.length >= QUEUE_MAX) return;
    queue.seen[key] = 'queued';
    queue.list = queue.list.concat([item]);
    pump();
  }

  /* A hovered button: its image starts now, at normal priority, and the
     queue waits for it. Intent beats the cap. */
  function loadNow(src) {
    if (!src) return;
    var item = { src: src, tile: false };
    var key = queueKey(item);
    if (queue.seen[key] === 'done') return;
    yieldQueue();
    queue.seen[key] = 'done';
    queue.list = queue.list.filter(function (entry) { return queueKey(entry) !== key; });
    queue.wanted = loadImage(item, 'auto');
    pump();
  }

  /* An image the user waits for: the main image, or a hovered target. */
  function awaited() {
    if (el.mainImg.getAttribute('src') && !el.mainImg.complete) return el.mainImg;
    if (queue.wanted && !queue.wanted.complete) return queue.wanted;
    return null;
  }

  function pump() {
    if (queue.current || queue.waiting || !queue.list.length) return;
    var wait = awaited();
    if (wait) {
      var gen = queue.gen;
      var resume = function () {
        wait.removeEventListener('load', resume);
        wait.removeEventListener('error', resume);
        if (gen !== queue.gen) return;
        queue.waiting = false;
        pump();
      };
      queue.waiting = true;
      wait.addEventListener('load', resume);
      wait.addEventListener('error', resume);
      return;
    }
    var item = queue.list[0];
    queue.list = queue.list.slice(1);
    queue.seen[queueKey(item)] = 'done';
    queue.started += 1;
    var mine = queue.gen;
    queue.current = {
      item: item,
      img: loadImage(item, 'low', function () {
        if (mine !== queue.gen) return;
        queue.current = null;
        pump();
      })
    };
  }

  /* Run fn with a few state fields changed, then put them back. Lets the
     queue ask "what shows after this click" through the click path's own
     pick logic, without changing the sheet. */
  function withState(patch, fn) {
    var saved = Object.assign({}, state);
    try {
      Object.assign(state, patch);
      return fn();
    } finally {
      Object.assign(state, saved);
    }
  }

  function firstImageFor(color, style) {
    return withState({ selectedColor: color, selectedStyle: style }, function () {
      var images = imagesForColor(color);
      return images.length ? images[0].src : null;
    });
  }

  function otherColours() {
    if (state.colorIndex < 0) return [];
    return state.product.options[state.colorIndex].values.filter(function (value) {
      return value !== state.selectedColor;
    });
  }

  function otherStyles() {
    if (state.styleIndex < 0) return [];
    return state.product.options[state.styleIndex].values.filter(function (value) {
      return value !== state.selectedStyle;
    });
  }

  /* Styles tiles for a colour, as 300px sources. */
  function styleTiles(color) {
    if (state.styleIndex < 0) return [];
    return state.product.options[state.styleIndex].values.map(function (value) {
      return styleThumb(color, value);
    }).filter(Boolean);
  }

  /* Order: thumb 2, then the other Styles, then the other colours, then
     thumbs 3 and up, then the other colours' Style tiles. A Style or colour
     click changes the whole sheet, so those come before the late thumbs.
     The cap cuts from the end. */
  function queueForSheet() {
    if (!state.product) return;
    /* Rebuilt for the new colour or Style. Not yet started is forgotten. */
    queue.list.forEach(function (entry) { delete queue.seen[queueKey(entry)]; });
    queue.list = [];
    var styles = otherStyles();
    var colours = otherColours();
    var shown = state.images[state.imageIndex];
    if (shown) queue.seen['false:' + imageKey(shown.src)] = 'done';
    /* This colour's Style tiles paint now, not after the queue. */
    styleTiles(state.selectedColor).forEach(function (src) {
      var img = new Image();
      img.src = sized(src, 300);
    });
    var stills = state.images.filter(function (item) { return !item.video; });
    stills.slice(0, 2).forEach(function (item) { enqueue(item.src); });
    styles.forEach(function (value) { enqueue(firstImageFor(state.selectedColor, value)); });
    colours.forEach(function (value) { enqueue(firstImageFor(value, state.selectedStyle)); });
    stills.slice(2).forEach(function (item) { enqueue(item.src); });
    colours.forEach(function (value) {
      styleTiles(value).forEach(function (src) { enqueue(src, true); });
    });
  }

  /* Hover or focus on a Style or colour button in the sheet: its image first. */
  function warmButton(target) {
    if (!state.product || el.root.hidden) return;
    var style = target.closest('[data-twrd-qa-style]');
    var swatch = target.closest('[data-twrd-qa-color]');
    var sibling = target.closest('[data-twrd-qa-sibling]');
    if (sibling) {
      var siblingHandle = sibling.getAttribute('data-twrd-qa-sibling');
      if (siblingHandle === state.product.handle) return;
      fetchProduct(siblingHandle)
        .then(function (product) {
          var first = pickImages(product, null)[0];
          if (first) loadNow(first.src);
        })
        .catch(function () {});
    } else if (style) {
      var value = style.getAttribute('data-twrd-qa-style');
      if (value !== state.selectedStyle) loadNow(firstImageFor(state.selectedColor, value));
    } else if (swatch) {
      var colour = swatch.getAttribute('data-twrd-qa-color');
      if (colour !== state.selectedColor) loadNow(firstImageFor(colour, state.selectedStyle));
    }
  }

  function onIntent(event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;
    var trigger = target.closest('[data-twrd-quickadd]');
    if (trigger) warm(trigger);
    else if (target.closest('[data-twrd-qa]')) warmButton(target);
  }

  function open(handle, trigger) {
    lastFocus = trigger || null;
    lastDialog = trigger && trigger.closest ? trigger.closest('[aria-modal="true"]') : null;
    state.trigger = trigger || null;
    queueReset();
    reset();
    el.root.hidden = false;
    document.body.classList.add('twrd-qa-locked');
    document.addEventListener('keydown', onKeydown, true);
    window.requestAnimationFrame(function () {
      el.root.classList.add('is-open');
    });
    var closeButton = el.sheet.querySelector('[data-twrd-qa-close]');
    if (closeButton) closeButton.focus();

    fetchProduct(handle)
      .then(function (product) {
        if (el.root.hidden) return;
        var groups = groupsFor(handle, trigger);
        state.colourGroup = groups.colours;
        state.editionGroup = groups.editions;
        prepare(product, trigger ? trigger.getAttribute('data-twrd-variant') : null);
        state.upcoming = isUpcoming(product, trigger);
        render();
      })
      .catch(function (error) {
        /* Aldrig et tomt ark: besked og et link til produktsiden. */
        el.loading.hidden = true;
        el.content.hidden = true;
        el.failed.hidden = false;
        el.failedLink.href = productRoot() + 'products/' + encodeURIComponent(handle);
        if (window.console) console.warn('twrd-quick-add: fetch failed', error);
      });
  }

  /* ---------- add to cart ---------- */

  function watchFormError(productForm, done) {
    var observer = new MutationObserver(function () {
      var node = productForm.querySelector('.errors');
      if (!node) return;
      observer.disconnect();
      done(node.textContent.trim() || 'Could not add to cart.');
    });
    observer.observe(productForm, { childList: true, subtree: true });
    return observer;
  }

  /* The card button that opened the sheet signs for the line: the bag turns
     into a check and a ring pulses out. It goes back to normal after 1.2s.
     Motion is switched off in CSS under prefers-reduced-motion. */
  var receiptButton = null;
  var receiptTimer = null;
  var addedTimer = null;

  function clearReceipt() {
    window.clearTimeout(receiptTimer);
    receiptTimer = null;
    if (receiptButton) receiptButton.classList.remove('is-added');
    receiptButton = null;
  }

  function receipt(button) {
    if (!button || !button.classList || !document.contains(button)) return;
    clearReceipt();
    receiptButton = button;
    /* Restart the animation if the same button is used twice in a row. */
    void button.offsetWidth;
    button.classList.add('is-added');
    receiptTimer = window.setTimeout(clearReceipt, 1200);
  }

  function addToCart() {
    if (!state.product || state.busy || state.upcoming) return;
    var match = resolve(state.selectedColor, state.selectedSize);
    if (!match.variant || !match.available) return;

    var input = el.form.querySelector('input[name="id"]');
    var productForm = el.form.closest('product-form');
    if (!input || !productForm) return;

    state.busy = true;
    state.phase = 'adding';
    el.error.hidden = true;
    renderAdd();
    input.value = String(match.variant.id);

    var settled = false;
    var observer = watchFormError(productForm, function (message) {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      document.removeEventListener('on:cart:loaded', onLoaded);
      state.busy = false;
      state.phase = 'idle';
      el.error.hidden = false;
      el.error.textContent = message;
      renderAdd();
    });

    function onLoaded() {
      if (settled) return;
      settled = true;
      observer.disconnect();
      window.clearTimeout(timer);
      /* Arket lukker med det samme i en hurtig fade, mens kurv-skuffen
         glider ind. Knappen naar at vise "Added", mens arket fader ud. */
      state.phase = 'added';
      renderAdd();
      receipt(state.trigger);
      close(true);
      addedTimer = window.setTimeout(function () {
        state.busy = false;
        state.phase = 'idle';
      }, FAST_CLOSE_MS);
    }

    var timer = window.setTimeout(function () {
      if (settled) return;
      settled = true;
      observer.disconnect();
      document.removeEventListener('on:cart:loaded', onLoaded);
      state.busy = false;
      state.phase = 'idle';
      el.error.hidden = false;
      el.error.textContent = 'Could not add to cart. Please try again.';
      renderAdd();
    }, 8000);

    document.addEventListener('on:cart:loaded', onLoaded, { once: true });

    if (typeof el.form.requestSubmit === 'function') {
      el.form.requestSubmit();
    } else {
      el.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  /* ---------- events ---------- */

  /* Mouse drag scrolls the image row. Touch and touchpad already scroll
     natively. A real drag swallows the click that follows it. */
  function addDragScroll(row) {
    var drag = null;
    var swallowClick = false;

    row.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target.closest('.twrd-qa__arrow')) return;
      drag = { x: event.clientX, left: row.scrollLeft, moved: false };
      row.classList.add('is-grabbing');
    });

    row.addEventListener('pointermove', function (event) {
      if (!drag) return;
      var delta = event.clientX - drag.x;
      if (!drag.moved && Math.abs(delta) < DRAG_THRESHOLD) return;
      if (!drag.moved) {
        drag = { x: drag.x, left: drag.left, moved: true };
        row.classList.add('is-dragging');
        if (row.setPointerCapture) row.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      row.scrollLeft = drag.left - delta;
    });

    function end(event) {
      if (!drag) return;
      swallowClick = drag.moved;
      drag = null;
      row.classList.remove('is-grabbing');
      row.classList.remove('is-dragging');
      if (event && row.hasPointerCapture && row.hasPointerCapture(event.pointerId)) {
        row.releasePointerCapture(event.pointerId);
      }
    }

    row.addEventListener('pointerup', end);
    row.addEventListener('pointercancel', end);
    row.addEventListener('lostpointercapture', end);

    row.addEventListener('click', function (event) {
      if (!swallowClick) return;
      swallowClick = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    row.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
  }

  function init() {
    if (!collect()) return;
    addDragScroll(el.images);
    if (el.upForm) el.upForm.addEventListener('submit', submitSignup);

    /* pointerenter does not bubble, so it is caught in the capture phase. */
    document.addEventListener('pointerenter', onIntent, true);
    document.addEventListener('focusin', onIntent);
    document.addEventListener('touchstart', onIntent, { capture: true, passive: true });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest ? event.target.closest('[data-twrd-quickadd]') : null;
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        open(trigger.getAttribute('data-twrd-quickadd'), trigger);
      }
    }, true);

    el.root.addEventListener('mouseover', onSiblingEnter);
    el.root.addEventListener('mouseout', onSiblingLeave);
    el.root.addEventListener('focusin', onSiblingEnter);
    el.root.addEventListener('focusout', onSiblingLeave);

    el.root.addEventListener('click', function (event) {
      if (event.target.closest('[data-twrd-qa-close]')) {
        event.preventDefault();
        close();
        return;
      }

      var sibling = event.target.closest('[data-twrd-qa-sibling]');
      if (sibling && state.product) {
        swapTo(sibling.getAttribute('data-twrd-qa-sibling'));
        return;
      }

      var swatch = event.target.closest('[data-twrd-qa-color]');
      if (swatch && state.product) {
        var colour = swatch.getAttribute('data-twrd-qa-color');
        if (colour !== state.selectedColor) {
          state.selectedColor = colour;
          var stillThere = state.selectedSize && resolve(colour, state.selectedSize).available;
          if (!stillThere) state.selectedSize = null;
          renderImages();
          renderSwatches();
          renderStyles();
          renderSizes();
          renderPrice();
          renderAdd();
        }
        return;
      }

      var style = event.target.closest('[data-twrd-qa-style]');
      if (style && state.product) {
        var styleValue = style.getAttribute('data-twrd-qa-style');
        if (styleValue !== state.selectedStyle) {
          state.selectedStyle = styleValue;
          var sizeStillThere = state.selectedSize && resolve(state.selectedColor, state.selectedSize).available;
          if (!sizeStillThere) state.selectedSize = null;
          renderImages();
          renderStyles();
          renderSizes();
          renderPrice();
          renderAdd();
        }
        return;
      }

      var thumb = event.target.closest('[data-twrd-qa-thumb]');
      if (thumb && state.product) {
        showMain(Number(thumb.getAttribute('data-twrd-qa-thumb')) || 0);
        return;
      }

      var size = event.target.closest('[data-twrd-qa-size]');
      if (size && state.product && !size.disabled) {
        state.selectedSize = size.getAttribute('data-twrd-qa-size');
        window.clearTimeout(nudgeTimer);
        el.sizeWrap.classList.remove('is-nudged');
        renderSizes();
        renderPrice();
        renderAdd();
        return;
      }

      if (event.target.closest('[data-twrd-qa-add]') && state.product) {
        if (addMode() === 'upcoming') {
          openSignup();
          return;
        }
        if (addMode() === 'select') {
          nudgeSizes(event.detail === 0);
          return;
        }
        addToCart();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
